// extracted by mini-css-extract-plugin
export var container = "_az-0";
export var content = "_az-3";
export var customerTitle = "_az-4";
export var empty = "_az-5";
export var gray = "_az-6";
export var header = "_az-7";
export var info = "_az-8";
export var loading = "_az-2";
export var loadingCard = "_az-9";
export var oneLine = "_az-a";
export var personName = "_az-e";
export var pillContainer = "_az-b";
export var selected = "_az-1";
export var text = "_az-c";
export var twoLines = "_az-d";
export var unread = "_az-f";
export var unreadIndicator = "_az-g";